import React, { useState } from 'react';
import styles from './AdminDiscountSingle.module.scss';
import AdminSinglePage from '../AdminSinglePage/AdminSinglePage';
import { userSingle } from '../../../redux/actions/user/userSingle';
import { resetUserSingle } from '../../../redux/slices/user.slice';
import { resetDiscountSingle, resetPostSingle } from '../../../redux/slices/app.slice';
import { postSingle } from '../../../redux/actions/app/postSingle';
import dayjs from 'dayjs';
import { discountSingle } from '../../../redux/actions/app/discountSingle';

const AdminDiscountSingle = () => {
  const data = [
    {
      label: 'Фото',
      type: 'image',
      name: 'image',
      width: '500px',
    },
    {
      label: 'Название',
      type: 'text',
      name: 'title',
      disabled: true,
    },
    [
      {
        type: 'image',
        name: 'avatar',
        width: '40px',
        grid: '40px 1fr',
      },
      {
        label: 'Создатель',
        type: 'text',
        name: 'user',
        disabled: true,
      },
    ],
    {
      label: 'Описание',
      type: 'textarea',
      name: 'description',
      disabled: true,
    },
  ];
  const [fields, setFields] = useState([]);
  const onFormatData = ({ discount: { title, image, description, club, createdAt } }) => {
    setFields(data);
    return { title, image, description, user: club?.name, avatar: club?.logo };
  };
  const deleteProps = { successText: 'Акция удален', confirmTitle: `Вы уверены что хотите удалить акцию`, confirmText: 'Комментарии также будут удалены', status: 'DELETED' };
  const blockProps = { successText: 'Акция заблокирована', confirmTitle: `Вы уверены что хотите заблокировать акцию`, confirmText: 'Комментарии также будут заблокированы', status: 'BLOCKED' };
  const unblockProps = { successText: 'Акция разблокирована', confirmTitle: `Вы уверены что хотите разблокировать акцию`, confirmText: 'Комментарии также будут разблокированы', status: 'ACTIVE' };
  return (
    <>
      <AdminSinglePage
        reset={resetDiscountSingle}
        fetch={discountSingle}
        sliceName={'app'}
        actionName={'discountSingle'}
        onFormatData={onFormatData}
        fields={fields}
        pathList="/admin/promotions"
        deleteProps={deleteProps}
        blockProps={blockProps}
        unblockProps={unblockProps}
        propName={'discount'}
        type={'PROMOTION'}
      />
    </>
  );
};

export default AdminDiscountSingle;
